import React, {useState} from 'react';
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import {Paper} from "@mui/material";
import AssignmentTwoToneIcon from "@mui/icons-material/AssignmentTwoTone";
import ListItemText from "@mui/material/ListItemText";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import FaceTwoToneIcon from '@mui/icons-material/FaceTwoTone';
import PeopleTwoToneIcon from '@mui/icons-material/PeopleTwoTone';
import ConfirmationNumberTwoToneIcon from '@mui/icons-material/ConfirmationNumberTwoTone';
import DateRangeTwoToneIcon from '@mui/icons-material/DateRangeTwoTone';
import QuestionAnswerTwoToneIcon from '@mui/icons-material/QuestionAnswerTwoTone';
import NoteTwoToneIcon from '@mui/icons-material/NoteTwoTone';
import ColorizeTwoToneIcon from '@mui/icons-material/ColorizeTwoTone';
import EuroSymbolTwoToneIcon from '@mui/icons-material/EuroSymbolTwoTone';
import InsertDriveFileTwoToneIcon from '@mui/icons-material/InsertDriveFileTwoTone';
import CreateTwoToneIcon from '@mui/icons-material/CreateTwoTone';
import ShoppingBasketTwoToneIcon from '@mui/icons-material/ShoppingBasketTwoTone';
import {getAccountInfo} from "../../../../utils/GenericUtils";
import TimelineTwoToneIcon from "@mui/icons-material/TimelineTwoTone";

const PazienteDrawer = ({selectMenuItem, stato}) => {
	const classes = BaseStyle();

	const [open, setOpen] = useState(true);

	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};

	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem button className={classes.roundBorder} selected={stato === "Diario"}
					          onClick={() => selectMenuItem("Diario")}>
						<ListItemIcon>
							<TimelineTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Timeline"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Anagrafica"}
					          onClick={() => selectMenuItem("Anagrafica")}>
						<ListItemIcon>
							<FaceTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Anagrafica"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Relazioni"}
					          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}
					          onClick={() => selectMenuItem("Relazioni")}>
						<ListItemIcon>
							<PeopleTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Anagrafiche relazionate"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={stato === "Ticket"}
					          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}
					          onClick={() => selectMenuItem("Ticket")}>
						<ListItemIcon>
							<ConfirmationNumberTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Ticket"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Isolamenti"}*/}
					{/*          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}*/}
					{/*          onClick={() => selectMenuItem("Isolamenti")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<DateRangeTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Isolamenti"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Interviste"}*/}
					{/*          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}*/}
					{/*          onClick={() => selectMenuItem("Interviste")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<QuestionAnswerTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Interviste"}/>*/}
					{/*</ListItem>*/}
					<ListItem button className={classes.roundBorder} selected={stato === "Note"}
					          onClick={() => selectMenuItem("Note")}>
						<ListItemIcon>
							<NoteTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Note"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Tampone"}*/}
					{/*          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}*/}
					{/*          onClick={() => selectMenuItem("Tampone")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<ColorizeTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Richiedi tampone"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Crea tampone"}*/}
					{/*          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}*/}
					{/*          onClick={() => selectMenuItem("Crea tampone")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<CreateTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Crea tampone"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Crea vaccino"}*/}
					{/*          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}*/}
					{/*          onClick={() => selectMenuItem("Crea vaccino")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<ShoppingBasketTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Crea vaccino"}/>*/}
					{/*</ListItem>*/}
					<ListItem button className={classes.roundBorder} selected={stato === "Documenti"}
					          disabled={getAccountInfo().roles?.includes("ROLE_SP_301_H")}
					          onClick={() => selectMenuItem("Documenti")}>
						<ListItemIcon>
							<InsertDriveFileTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Documenti"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={stato === "Altro"}*/}
					{/*          onClick={() => selectMenuItem("Altro")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<EuroSymbolTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Altro"}/>*/}
					{/*</ListItem>*/}
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(PazienteDrawer)
